module.exports = __webpack_public_path__ + "img/ep5-3.3a762c4c.png";